import { render, staticRenderFns } from "./PropertyPart.vue?vue&type=template&id=3eac2c5a&"
import script from "./PropertyPart.vue?vue&type=script&lang=ts&"
export * from "./PropertyPart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports